module.exports = __webpack_public_path__ + "static/media/evacuation.73fb90cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/products/evacuation.jpg
// module id = 89
// module chunks = 0